// extracted by mini-css-extract-plugin
export default {"separator":"stagesection_separator__pwLno"};